import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const UnexpectedError = () => {
  const navigate = useNavigate();

  return (
    <section className="flex h-screen flex-col items-center justify-center gap-3">
      <h1 className="text-3xl font-semibold tracking-tight">
        Something went wrong...
      </h1>
      <p className="px-4 text-center text-muted-foreground">
        Sorry, something went wrong there. Please try refresh the page.
      </p>
      <Button
        className="bg-[#fed435] text-sm font-normal text-gray-900 hover:bg-[#f5d974]"
        onClick={() => {
          navigate("/admin/stores", { replace: true });
          window.location.reload();
        }}
      >
        Refresh
      </Button>
    </section>
  );
};

export default UnexpectedError;
